<div class="inner" [hidden]="!this.isOpen" (clickOutside)="outsideClick()">
	<div *ngFor="let item of options">
		<div class="header">
			<div class="icon"><i class="fa" [ngClass]="item.headerIcon"></i></div>
			<div>{{ item.headerLabel }}</div>
		</div>
		<div class="options">
			<div *ngFor="let option of item.options" class="option" [class.active]="option.active" [class.disabled]="option.disabled" (click)="optionSelect(item, option, $event)">
				<div class="icon"><i class="fa" [ngClass]="{ 'fa-check' : option.active }"></i></div>
				<div>{{ option.label }}</div>				
			</div>
		</div>
	</div>
</div>
